import { c as _c } from "react/compiler-runtime";
import type { UserTimelineEventDocumentUploaded } from '@onefootprint/request-types/dashboard';
import { IdDocStatus } from '@onefootprint/types';
import { useTranslation } from 'react-i18next';
type DocumentUploadedEventHeaderProps = {
  data: UserTimelineEventDocumentUploaded['data'];
};
const DocumentUploadedEventHeader = t0 => {
  const $ = _c(26);
  const {
    data
  } = t0;
  const {
    t
  } = useTranslation("common");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "auditTrail.timeline.documentUploadedEvent"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t: entityT
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== entityT) {
    t2 = entityT(_temp);
    $[1] = entityT;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== entityT) {
    t3 = entityT(_temp2);
    $[3] = entityT;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== entityT) {
    t4 = entityT(_temp3);
    $[5] = entityT;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== entityT) {
    t5 = entityT(_temp4);
    $[7] = entityT;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t2 || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = {
      [IdDocStatus.complete]: t2,
      [IdDocStatus.pending]: t3,
      [IdDocStatus.failed]: t4,
      [IdDocStatus.abandoned]: t5
    };
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const statusT = t6;
  let documentType;
  if (data.config.kind === "custom") {
    documentType = data.config.data.name;
  } else {
    let t7;
    if ($[14] !== data.documentType) {
      t7 = $_3 => $_3.id_document[data.documentType];
      $[14] = data.documentType;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    let t8;
    if ($[16] !== t || $[17] !== t7) {
      t8 = t(t7);
      $[16] = t;
      $[17] = t7;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    documentType = t8;
  }
  const t7 = statusT[data.status];
  let t8;
  if ($[19] !== t7) {
    t8 = <p className="text-body-2 text-tertiary">{t7}</p>;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== documentType) {
    t9 = <p className="text-label-2">{documentType}</p>;
    $[21] = documentType;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t8 || $[24] !== t9) {
    t10 = <div className="flex items-center justify-start flex-wrap gap-1">{t8}{t9}</div>;
    $[23] = t8;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
export default DocumentUploadedEventHeader;
function _temp($) {
  return $.title.complete;
}
function _temp2($_0) {
  return $_0.title.pending;
}
function _temp3($_1) {
  return $_1.title.failed;
}
function _temp4($_2) {
  return $_2.title.abandoned;
}